module.exports = __webpack_public_path__ + "static/media/TMT 1c3.4c8ee08c.jpg";